<template>
  <b-form class="col-md-12">
    <b-row>
      <b-col sm="12">
        <b-alert v-if="FormCompleted" show variant="primary"
          >Bahagian ini telah lengkap. ✔</b-alert
        >
        <b-alert v-else show variant="warning"
          >Bahagian ini tidak lengkap.</b-alert
        >
        <hr />
      </b-col>
    </b-row>
    <b-row>
        <b-col sm="12">
          <b-alert show variant="warning"><a class="alert-link">Alamat baris 3 jika tiada, tidak perlu diisi harap maklum.</a></b-alert>
          <hr />
        </b-col>
      </b-row>
    <b-row>
      <b-col sm="12">
        <b-form-group label="Alamat Baris 1" label-for="address1">
          <template v-slot:label>
            Alamat Baris 1
            <span v-if="Address1 == 0" class="text-danger">*</span>
            <span v-else>✔</span>
          </template>
          <b-form-input
            id="address1"
            type="text"
            placeholder
            :disabled="Busy === true || Submitted === true"
            v-model="Address1"
            maxlength="100"
            required
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-form-group label="Alamat Baris 2" label-for="address2">
          <template v-slot:label>
            Alamat Baris 2
            <span v-if="Address2 == 0" class="text-danger">*</span>
            <span v-else>✔</span>
          </template>
          <b-form-input
            id="address2"
            type="text"
            placeholder
            :disabled="Busy === true || Submitted === true"
            v-model="Address2"
            maxlength="100"
            required
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-form-group label="Alamat Baris 3" label-for="address3">
          <b-form-input
            id="address3"
            type="text"
            placeholder
            :disabled="Busy === true || Submitted === true"
            v-model="Address3"
            maxlength="100"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-form-group label="Poskod" label-for="postCode">
          <template v-slot:label>
            Poskod
            <span v-if="Postcode == 0" class="text-danger">*</span>
            <span v-else>✔</span>
          </template>
          <b-form-input
            id="postCode"
            type="text"
            placeholder
            :disabled="Busy === true || Submitted === true"
            v-model="Postcode"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-form-group label="Negara" label-for="country">
          <template v-slot:label>
            Negara
            <span v-if="CountryId == 0" class="text-danger">*</span>
            <span v-else>✔</span>
          </template>
          <b-form-select
            id="country"
            :disabled="Busy === true || Submitted === true"
            v-model="CountryId"
          >
            <DefaultOption />
            <option
              v-for="item in Countries"
              v-bind:value="item.Id"
              :key="item.Id"
            >{{ item.Name }}</option>
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col sm="12">
        <div v-if="this.CountryId==130">
          <b-form-group label="Negeri" label-for="state">
            <template v-slot:label>
            Negeri
            <span v-if="StateId == 0" class="text-danger">*</span>
            <span v-else>✔</span>
          </template>
            <b-form-select
              id="state"
              :disabled="Busy === true || Submitted === true"
              v-model="StateId"
              @change="CityId = 0"
            >
              <DefaultOption />
              <option
                v-for="item in States"
                v-bind:value="item.Id"
                :key="item.Id"
              >{{ item.Name }}</option>
            </b-form-select>
          </b-form-group>
        </div>

        <div v-else-if="this.CountryId!=0">
          <b-form-group label="Nama Negeri" label-for="otherStates">
            <template v-slot:label>
            Nama Negeri
            <span v-if="OtherStateName == 0" class="text-danger">*</span>
            <span v-else>✔</span>
          </template>
            <b-form-input
              id="otherStates"
              type="text"
              placeholder
              :disabled="Busy === true || Submitted === true"
              v-model="OtherStateName"
            ></b-form-input>
          </b-form-group>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <div v-if="this.StateId!=0">
          <b-form-group label="Bandar" label-for="city">
            <template v-slot:label>
            Bandar
            <span v-if="CityId == 0" class="text-danger">*</span>
            <span v-else>✔</span>
          </template>
            <b-form-select
              id="city"
              :disabled="Busy === true || Submitted === true"
              v-model="CityId"
            >
              <DefaultOption />
              <option
                v-for="item in Cities"
                v-bind:value="item.Id"
                :key="item.Id"
              >{{ item.Name }}</option>
            </b-form-select>
          </b-form-group>
        </div>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import DefaultOption from "./DefaultOption";
import _ from "lodash";

export default {
  name: "AddressBook",
  props: ["others", "type"],
  components: {
    DefaultOption
  },
  computed: {
    FormCompleted: {
      get: function () {
        let complete = true;
        if (
          this.Address1 == 0 ||
          this.Address2 == 0 ||
          this.Postcode == 0 ||
          //this.CityId == 0 ||
          this.CountryId == 0 //||
          //this.StateId == 0
        ) 
        complete = false;
        else {
          if (this.CountryId == 130){
             if (this.StateId == 0 || this.CityId == 0) complete = false;
          } else {
            if (this.OtherStateName == 0) complete = false;
          }
        }
        this.$store.dispatch(
          "addressBook/updateFormCompleted",
          complete
        );
        return complete;
      },
    },
    Busy: {
      get: function() {
        return this.$store.getters["common/Busy"];
      },
      set: function(value) {
        this.$store.dispatch("common/updateBusy", value);
      }
    },
    Submitted: {
      get: function() {
        return this.$store.getters["common/Submitted"];
      },
      set: function(value) {
        this.$store.dispatch("common/updateSubmitted", value);
      }
    },
    ModuleName: {
      get: function() {
        if (this.type == "applicant") {
          switch (this.others) {
            case "permanent":
              return "appPermanentAddress";
            case "mail":
              return "appMailAddress";
            case "employment":
              return "appEmployerAddress";
            default:
              break;
          }
        } else if (this.type == "personal") {
          switch (this.others) {
            case "spouse":
              return "spousePersonalAddress";
            case "father":
              return "fatherPersonalAddress";
            case "mother":
              return "motherPersonalAddress";
            case "guardian":
              return "guardianPersonalAddress";
            case "family":
              return "familyPersonalAddress";
            case "guarantor1":
              return "guarantor1PersonalAddress";
            case "guarantor2":
              return "guarantor2PersonalAddress";
            case "permanent":
              return "appPermanentAddress";
            case "mail":
              return "appMailAddress";
            default:
              break;
          }
        } else if (this.type == "employment") {
          switch (this.others) {
            case "spouse":
              return "spouseEmployerAddress";
            case "father":
              return "fatherEmployerAddress";
            case "mother":
              return "motherEmployerAddress";
            case "guardian":
              return "guardianEmployerAddress";
            case "family":
              return "familyEmployerAddress";
            case "guarantor1":
              return "guarantor1EmployerAddress";
            case "guarantor2":
              return "guarantor2EmployerAddress";
            case "applicant":
              return "appEmployerAddress";
            default:
              break;
          }
        }
      }
    },
    Id: {
      get: function() {
        return this.$store.getters["addressBook/Id"];
      },
      set: function(value) {
        this.$store.dispatch("addressBook/updateId", value);
      }
    },
    Address1: {
      get: function() {
        return this.$store.getters["addressBook/Address1"];
      },
      set: function(value) {
        this.$store.dispatch("addressBook/updateAddress1", value);
      }
    },
    Address2: {
      get: function() {
        return this.$store.getters["addressBook/Address2"];
      },
      set: function(value) {
        this.$store.dispatch("addressBook/updateAddress2", value);
      }
    },
    Address3: {
      get: function() {
        return this.$store.getters["addressBook/Address3"];
      },
      set: function(value) {
        this.$store.dispatch("addressBook/updateAddress3", value);
      }
    },
    Postcode: {
      get: function() {
        return this.$store.getters["addressBook/Postcode"];
      },
      set: function(value) {
        this.$store.dispatch("addressBook/updatePostcode", value);
      }
    },
    CityId: {
      get: function() {
        return this.$store.getters["addressBook/CityId"];
      },
      set: function(value) {
        this.$store.dispatch("addressBook/updateCity", value);
      }
    },
    StateId: {
      get: function() {
        return this.$store.getters["addressBook/StateId"];
      },
      set: function(value) {
        this.$store.dispatch("addressBook/updateState", value);
      }
    },
    CountryId: {
      get: function() {
        return this.$store.getters["addressBook/CountryId"];
      },
      set: function(value) {
        this.$store.dispatch("addressBook/updateCountry", value);
      }
    },
    OtherStateName: {
      get: function() {
        return this.$store.getters["addressBook/OtherStateName"];
      },
      set: function(value) {
        this.$store.dispatch("addressBook/updateOtherStateName", value);
      }
    },

    // Common
    Countries: {
      get: function() {
        return this.$store.getters["places/Countries"];
      }
    },
    States: {
      get: function() {
        return this.$store.getters["places/States"];
      }
    },
    Cities: {
      get: function() {
        let arr = this.$store.getters["places/Cities"];
        let filtered = _.filter(arr, ["StateId", this.StateId]);
        filtered = _.orderBy(filtered, ["Name"], ["asc"]);

        return filtered;
      }
    }
  },
  async mounted() {
    this.ClearFields();
    let isAuth = await this.UserAuth();

    if (isAuth) if (this.type !== "insert") this.GetAddress();
  },
  methods: {
    validate(e) {
      if (!this.$v.valid) {
        e.preventDefault();
        alert("not valid!");
      }
    },
    ClearFields() {
      this.Id = 0;
      this.Address1 = "";
      this.Address2 = "";
      this.Address3 = "";
      this.Postcode = "";
      this.CityId = 0;
      this.StateId = 0;
      this.CountryId = 130;
      this.OtherStateName = "";
    },
    GetAddress() {
      if (this.type == "applicant") {
        switch (this.others) {
          case "permanent":
            this.API = this.$PermanentAddress;
            break;
          case "mail":
            this.API = this.$MailAddress;
            break;
          case "employment":
            this.API = this.$CurrentEmploymentAddress;
            break;
          default:
            break;
        }
      } else if (this.type == "personal") {
        switch (this.others) {
          case "spouse":
          case "father":
          case "mother":
          case "guardian":
          case "family":
          case "guarantor1":
          case "guarantor2":
            this.API = this.$PersonalAddress + "/" + this.others;
            break;
          case "permanent":
            this.API = this.$PermanentAddress;
            break;
          case "mail":
            this.API = this.$MailAddress;
            break;
          default:
            break;
        }
      } else if (this.type == "employment") {
        switch (this.others) {
          case "spouse":
          case "father":
          case "mother":
          case "guardian":
          case "family":
          case "guarantor1":
          case "guarantor2":
            this.API = this.$EmploymentAddress + "/" + this.others;
            break;
          case "applicant":
            this.API = this.$CurrentEmploymentAddress;
            break;
          default:
            break;
        }
      }

      return this.$API
        .get(this.API, { withCredentials: true })
        .then(response => {
          this.info = response.data;
          if (response.status == 200 && this.info != null) {
            this.Id = this.info.Id;
            this.Address1 = null != this.info.Address1 ? this.info.Address1.toUpperCase() : this.info.Address1;
            this.Address2 = null != this.info.Address2 ? this.info.Address2.toUpperCase() : this.info.Address2;
            this.Address3 = null != this.info.Address3 ? this.info.Address3.toUpperCase() : this.info.Address3;
            this.Postcode = this.info.Postcode;
            this.CityId = this.info.CityId;
            this.StateId = this.info.StateId;
            this.CountryId = this.info.CountryId;
            this.OtherStateName = null != this.info.OtherStateName ? this.info.OtherStateName.toUpperCase() : this.info.OtherStateName;
          } else {
            console.log(this.info.detail);
            this.Loading = false;
            this.Error = true;
          }
        })
        .catch(error => {
          if (error.response) {
            console.log(error.response.status);
          }
          console.log(error);
          this.Loading = false;
          this.Error = true;
          this.Message = error;
        });
    }
  }
};
</script>
